"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var lodash_1 = require("lodash");
var Skeleton_1 = require("../Skeleton");
var MomentTimelineCollapsible = function (_a) {
    /*
      Todo:
      1. Sepaarate data in intervals.
    */
    var data = _a.data, _b = _a.interval, interval = _b === void 0 ? "d" : _b, renderTitle = _a.renderTitle, collapsePanelProps = _a.collapsePanelProps, collapseProps = _a.collapseProps, collapsePropsProvided = _a.collapsePropsProvided, timelineItemProps = _a.timelineItemProps, timelineProps = _a.timelineProps, renderTimelineItem = _a.renderTimelineItem, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.loadingNum, loadingNum = _d === void 0 ? 2 : _d, _e = _a.formats, formats = _e === void 0 ? {
        /* Todo:
          The following Yesterday and Today are not localized. Make them localized.
        */
        lastDay: "[Yesterday]",
        sameDay: "[Today]",
        nextDay: "[Tomorrow]",
        lastWeek: "[Last] dddd",
        nextWeek: "dddd",
        sameElse: "L",
    } : _e;
    var sortedData = data.sort(function (a, b) {
        return moment_1.default(a.time).isBefore(b.time) ? 1 : -1;
    });
    var chunks = lodash_1.groupBy(sortedData, function (b) {
        return moment_1.default(b.time).startOf(interval).calendar(null, formats);
    });
    if (loading)
        return (react_1.default.createElement(antd_1.Row, null, Array(loadingNum)
            .fill(0)
            .map(function () { return (react_1.default.createElement(antd_1.Col, { xs: 24 },
            react_1.default.createElement(Skeleton_1.StyledSkeleton, { size: "small", active: true }))); })));
    var groupedByDateKeys = Object.keys(chunks);
    return (react_1.default.createElement(antd_1.Collapse, __assign({}, collapseProps, ((collapsePropsProvided === null || collapsePropsProvided === void 0 ? void 0 : collapsePropsProvided(groupedByDateKeys)) || {})), groupedByDateKeys.map(function (k) {
        var datums = chunks[k];
        return (react_1.default.createElement(antd_1.Collapse.Panel, __assign({}, collapsePanelProps, { header: renderTitle(k, datums.length), key: k }),
            react_1.default.createElement(antd_1.Timeline, __assign({}, timelineProps), datums.map(function (_a) {
                var innerTimelineItemProps = _a.timelineItemProps, time = _a.time, data1 = _a.data;
                return (react_1.default.createElement(antd_1.Timeline.Item, __assign({}, timelineItemProps, innerTimelineItemProps), renderTimelineItem({ time: time, data: data1 })));
            }))));
    })));
};
exports.default = MomentTimelineCollapsible;
